const ITEM_STATES = {
  DISPLAYING: 0, DROPPED: 1, SAVED: 2,
};

export default ITEM_STATES;